import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseResponseDto } from '../../domain/baseResponse';
import { BankingPortalLiteResponseDto } from '../../domain/BankingPortalLite';
import { ServiceName } from '../../enums/Services';
import { ApiService } from '../ApiService';

export const delay = async (ms: number): Promise<NodeJS.Timeout> => new Promise((resolve) => { setTimeout(resolve, ms); });

// Define a service using a base URL and expected endpoints
export const bankingPortalLiteApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: ApiService.GetServiceBaseUrl(ServiceName.Api) }),
  reducerPath: 'bankingPortalLiteApi',
  // baseQuery: fetchBaseQuery({ baseUrl: ApiService.GetServiceBaseUrl(ServiceName.Api) }),
  endpoints: (builder) => ({
    // currently using queryFn for using testdata https://redux-toolkit.js.org/rtk-query/usage-with-typescript#typing-a-queryfn
    getBankingPortalLiteById: builder.query<BaseResponseDto<BankingPortalLiteResponseDto> | undefined, string | undefined>({
      query: (id) => `Datacenter/${id}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetBankingPortalLiteByIdQuery } = bankingPortalLiteApi;
